import { AxiosError } from 'axios';
import * as Sentry from '@sentry/browser';

/**
 * Centralised API error handler — web port of the legacy
 * `utils/apiErrorHandler`. Logs, reports to Sentry, and re-throws so the
 * caller (mutation/query) enters its error state.
 *
 * Non-critical streaming-service 403s are expected — they are logged but not
 * surfaced as a modal by callers.
 */
export function handleApiError(error: unknown, context?: string): never {
  const axiosError = error as AxiosError;
  const status = axiosError?.response?.status;

  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(`[API error]${context ? ` (${context})` : ''}:`, status, axiosError?.message);
  }

  // Report unexpected errors. Auth-cancellations / expected 403s stay quiet.
  if (!status || status >= 500 || status === 400) {
    Sentry.captureException(error, { tags: { context: context ?? 'api' } });
  }

  throw error;
}
